var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"L0"}},[_c('div',{staticClass:"wrapper"},[_c('kg-header'),_vm._v(" "),_c('kg-login'),_vm._v(" "),_c('kg-footer',{attrs:{"toContactEventFlg":false}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b7060e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/kagull/pages/Login.vue
// module id = null
// module chunks = 